<template>
  <TListContainer>
    <TListItem
      v-for="(location, index) in predictions"
      :key="location.placeId"
    >
      <button
       
        :data-ddid="`location-dropdown-option-${location.placeId}`"
        type="button"
        class="bg-white hover:bg-gray-50 cursor-pointer text-primary-950 px-4 py-3 w-full text-left"
        @click="emit('set-place', location)"
      >
        {{ location.mainText?.text }}
        <small class="block text-gray-500">{{ location.secondaryText?.text ?? '' }}</small>
      </button>
    </TListItem>
  </TListContainer>
</template>

<script setup lang="ts">
defineProps<{
  predictions: google.maps.places.PlacePrediction[]
}>()

const emit = defineEmits<{
  'set-place': [location: google.maps.places.PlacePrediction]
}>()
</script>
